import isVizio from '@accedo/xdk-device-vizio-smartcast-contrib/esm/detection'
import { Lightning, Registry } from '@lightningjs/sdk'

import { getColor, grey300, grey50, grey700, grey960 } from '../../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../../constants/fonts'
import { BORDER_RADIUS } from '../../constants/general'
import { SearchModel } from '../../types/flo-experience'
import { getIcon } from '../../utils/image'

const CURSOR_BLINK_DELAY = 750
export default class SearchInput extends Lightning.Component {
  private _data: SearchModel
  private _query = ''
  private _placeholder = ''
  private _cursorIntervalId

  static _template() {
    return {
      w: 1228,
      h: 84,
      rect: true,
      color: getColor(grey960),
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        stroke: 2,
        strokeColor: getColor(grey700),
        fillColor: getColor(grey960),
        radius: BORDER_RADIUS,
      },
      flex: {
        direction: 'row',
        alignItems: 'center',
      },
      Icon: {
        color: getColor(grey50),
        shader: null,
        texture: Lightning.Tools.getSvgTexture(getIcon('icon-search'), 32, 32),
        flexItem: { marginLeft: 32, marginRight: 24 },
      },
      SearchTerm: {
        y: 4,
        shader: null,
        text: {
          text: '',
          fontSize: 32,
          fontFace: UniNeueRegular,
          textColor: getColor(grey300),
          wordWrap: false,
          wordWrapWidth: 1128,
          textOverflow: 'ellipsis',
          maxLines: 1,
          maxLinesSuffix: '...',
        },
      },
      SearchCursor: {
        h: 35,
        w: 2,
        y: 2,
        rect: true,
        color: getColor(grey300),
        shader: null,
        alpha: 1,
        visible: false,
        flexItem: {
          marginLeft: 2,
        },
      },
    }
  }

  get searchTerm() {
    return this.tag('SearchTerm')
  }

  get searchCursor() {
    return this.tag('SearchCursor')
  }

  set data(v: SearchModel) {
    this._data = v

    this.renderInputData(v)
  }

  get data() {
    return this._data
  }

  set query(v: string) {
    if (v !== this._query) {
      this._query = v || ''
      this.setSearchTerm()
    }

    this.signal('onSearchTermChange', v)
  }

  get query() {
    return this._query
  }

  _disable() {
    Registry.clearInterval(this._cursorIntervalId)
  }

  renderInputData(data: SearchModel) {
    this._placeholder = data?.placeholder_text

    Registry.clearInterval(this._cursorIntervalId)
    this._cursorIntervalId = Registry.setInterval(() => {
      this.searchCursor.alpha = this.searchCursor.alpha === 0 && isVizio ? 1 : 0
    }, CURSOR_BLINK_DELAY)

    this.searchTerm.patch({
      text: {
        text: data?.placeholder_text ?? '',
      },
    })
  }

  toggleInput(toggle: boolean) {
    this.patch({
      shader: {
        strokeColor: toggle ? getColor(grey50) : getColor(grey700),
      },
    })

    this.searchCursor.visible = toggle && this.query !== ''
  }

  setSearchTerm() {
    this.searchTerm.patch({
      text: {
        text: this.query === '' ? this._placeholder : this.query,
        textColor: this.query === '' ? getColor(grey300) : getColor(grey50),
        fontFace: this.query === '' ? UniNeueRegular : UniNeueBold,
      },
    })

    this.searchCursor.visible = this.query !== ''
  }

  setQueryString(query: string) {
    this._query = query
    this.setSearchTerm()
  }
}
